import FormSelect, { FormSelectProps } from '../templates/FormSelect';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { useGetInstitutions } from '@vindr/services/actions/institution.action';

interface InstitutionList<T> extends FormSelectProps<T> {
  keyValue?: 'code' | 'id';
  [key: string]: any;
}

const InstitutionList = <T,>({
  name = 'institutions',
  label = 'Institutions',
  placeholder = 'Select Institutions',
  rules,
  multiple = true,
  required = false,
  onChange,
  keyValue = 'id',
  disabled,
  ...props
}: InstitutionList<T>) => {
  const [searchTerm, handleSearch] = useDebounce<string>();

  const { data, isInitialLoading, isRefetching } = useGetInstitutions({
    limit: 100,
    offset: 0,
    ...(searchTerm && { name: searchTerm }),
  });

  const institutions = data?.data || [];

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...(multiple && { mode: 'multiple' })}
      loading={isInitialLoading || isRefetching}
      {...(onChange && { onChange })}
      {...(rules || (required && { rules: rulesMemo }))}
      {...{ name, label, placeholder, disabled, ...props }}
      options={institutions?.map((institution) => ({
        label: institution.name,
        value: institution[keyValue],
      }))}
      onSearch={handleSearch}
      showSearch
    />
  );
};

export default InstitutionList;
